import { ReactNode } from 'react';
import { cx } from '../../../payease.utils';
import './section-label.scss';

interface ISectionLabelProps {
  children: ReactNode;
  accent?: boolean;
  strong?: boolean;
  className?: string;
}

export const SectionLabel = ({ children, accent, strong, className }: ISectionLabelProps) => (
  <p className={cx('pe-eyebrow', accent && 'pe-eyebrow--accent', strong && 'pe-eyebrow--strong', className)}>{children}</p>
);
